module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_clock.e4cfc.png";